<span
    class="editable-popover-trigger"
    role="button"
    [attr.tabindex]="disabled ? -1 : 0"
    [attr.aria-disabled]="disabled"
    [attr.aria-label]="'Edit ' + displayLabel"
    [class.disabled]="disabled"
    (click)="open($event); $event.stopPropagation()"
    (keydown.enter)="open($event); $event.preventDefault(); $event.stopPropagation()"
    (keydown.space)="open($event); $event.preventDefault(); $event.stopPropagation()">
  <span class="editable-popover-value">{{displayLabel}}</span>
  <fa-icon class="editable-popover-icon" [icon]="faPencil" [fixedWidth]="true" aria-hidden="true"></fa-icon>
</span>

<p-popover
    #popover
    appendTo="body"
    [focusOnShow]="false"
    [dismissable]="!saving"
    ariaLabel="Edit value"
    (onShow)="focusTextInput()"
    (onHide)="resetDraft()">
  <div class="editable-popover-panel" (keydown.escape)="cancel(); $event.stopPropagation()">
    @if (usesTextInput) {
      <input
          #textInput
          type="text"
          pInputText
          autocomplete="off"
          [(ngModel)]="draftText"
          [disabled]="saving"
          (keydown.enter)="saveValue(); $event.preventDefault()">
    }

    @if (usesBooleanToggle) {
      <div class="editable-popover-toggle" role="group" aria-label="Select value">
        <button type="button" class="editable-popover-option" [class.active]="draftValue === true" [disabled]="saving" (click)="selectBoolean(true)">Yes</button>
        <button type="button" class="editable-popover-option" [class.active]="draftValue === false" [disabled]="saving" (click)="selectBoolean(false)">No</button>
      </div>
    }

    @if (usesOptionButtons) {
      <div class="editable-popover-options" role="group" aria-label="Select value">
        @for (option of options; track option) {
          <button type="button" class="editable-popover-option" [class.active]="draftValue === option" [disabled]="saving" (click)="selectOption(option)">{{formatValue(option)}}</button>
        }
      </div>
    }

    @if (usesSelect) {
      <p-select appendTo="body" [options]="options" [(ngModel)]="draftValue" [disabled]="saving"></p-select>
    }

    <div class="editable-popover-actions">
      <button type="button" pButton class="p-button-secondary" label="Cancel" [disabled]="saving" (click)="cancel()"></button>
      <button type="button" pButton label="OK" [disabled]="saveDisabled" (click)="saveValue()">
        @if (saving) {
          <fa-icon [icon]="faCog" animation="spin" [fixedWidth]="true"></fa-icon>
        }
      </button>
    </div>
  </div>
</p-popover>
